module.exports = __webpack_public_path__ + "media/components/country-flag/static/ir-403b8c47527b508230933a4e19d06503.svg";